import { apiCall } from "./servicesCall";

export const CHAT_SERVICES = {
  chatUpdate(data) {
    return apiCall("/chat/update", data);
  },
  getChatList(data) {
    return apiCall("/chat/list", data);
  },
  getHistoryList(data) {
    return apiCall("/chat/history", data);
  },
};
